// import { Router } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, Injectable, importProvidersFrom } from '@angular/core';
import { AppComponent } from './app.component';
import { appRoutingModule } from './app.routing';
import { HomeComponent } from './home';
import { LoggedInLayoutComponent } from './loggedInLayout';
import { AuthenticationModule } from './authentication';
import { DayScheduleModule } from './daySchedule';
import { ProfileModule } from './profile';
import { SettingsModule } from './settings';
import { EnvironmentService } from './environment.service';
// import { DataService } from './data.service';
// import { AngularTokenModule } from './angular-token';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AUTH_CONFIG } from './auth.config';
import { authInterceptor } from './auth.interceptor';
// import { HttpClientModule, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
// import { DirectivesModule } from './directives';
import { PipesModule } from './pipes';
// import { MomentModule } from 'ngx-moment';
import * as moment from 'moment';
import { ModalModule } from 'ngx-bootstrap/modal';
// import * as locales from 'moment/min/locales';
// import { enableProdMode } from '@angular/core';
// import { GlobalErrorHandler } from './globalErrorHandler';
import { AllocationRequestsModule } from './allocationRequests';
import { MonthScheduleModule } from './monthSchedule';
import { TrainingScheduleModule } from './trainingSchedule';
import { AgendaModule } from './agenda';
import { PopulatedReportsModule } from './populatedReports';
import { TrainingCandidatesModule } from './trainingCandidates';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { GlobalErrorHandler } from './globalErrorHandler';
// import { Observable } from 'rxjs/internal/Observable';
// import { tap } from 'rxjs/operators';
// import { NgSelectModule } from '@ng-select/ng-select';

registerLocaleData(localeNl);
moment.locale('nl');

// if (window.location.host !== 'localhost:3000') {
// 	enableProdMode();
// }

var apiBase = "";
switch(process.env.RAILS_ENV) {
	case "development":
		apiBase = "http://localhost:3000";
		break;
	case "production":
		apiBase = 'https://easyplanner.nl';
		break;
	case "backup":
		apiBase = 'https://backup.easyplanner.nl';
		break;
}

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {

//   	constructor(
// 		private router: Router,
// 		private toastr: ToastrService
// 	) {}

//   	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     	// const currentUser = JSON.parse(localStorage.getItem('currentUser'));
//     	// if (currentUser && currentUser.token) {
//       	// 	request = request.clone({
//         // 		setHeaders: {
//         //   			'Content-Type': 'application/json',
//         //   			Authorization: `JWT ${currentUser.token}`
//         // 		}
//       	// 	});
//     	// }

//     	return next.handle(request).pipe( tap(() => {},
//       		(err: any) => {
//       			if (err instanceof HttpErrorResponse) {
//         			if (err.status !== 401) {
//          				return;
//         			}
// 					this.toastr.error('Uw sessie is verlopen. Log opnieuw in.');
// 					this.router.navigate(["/login"]);
// 				}
//     	}));
//   	}
// }

@NgModule({
  	declarations: [
		AppComponent,
		HomeComponent,
		LoggedInLayoutComponent
  	],
  	imports: [
     	BrowserModule,
	 	AuthenticationModule,
		appRoutingModule,
    //	AngularTokenModule.forRoot({
	//		apiBase: apiBase,
	//		signInPath: 'users/sign_in.json',
	//		signOutPath: 'users/sign_out.json',
	//		signInRedirect: '/login'
    //	}),
	 	DayScheduleModule,
		ProfileModule,
		FormsModule,
	// 	DirectivesModule,
	// 	MomentModule,
	 	BrowserAnimationsModule,
	 	ToastrModule.forRoot(),
		SettingsModule,
		AllocationRequestsModule,
		MonthScheduleModule,
		TrainingScheduleModule,
		TrainingCandidatesModule,
	 	AgendaModule,
		PopulatedReportsModule,
	 	PipesModule
	],
  	providers: [
	// 	{
	// 		provide: HTTP_INTERCEPTORS,
	// 		useFactory: function(router:Router, toastr: ToastrService) {
	// 		  return new AuthInterceptor(router, toastr)
	// 		},
	// 		multi: true,
	// 		deps: [Router, ToastrService]
	// 	},
	 	EnvironmentService,
		{ 
			provide: AUTH_CONFIG, 
			useValue: {
				apiBase: apiBase,
				signInPath: 'users/sign_in.json',
				signOutPath: 'users/sign_out.json'
			}
		},
		provideHttpClient(withInterceptors([authInterceptor])),
	// 	DataService,
	// 	AngularTokenModule,
	// 	ToastrService,
		// {
		// 	provide: ErrorHandler, 
		// 	useClass: GlobalErrorHandler
		// },

		DatePipe,
		importProvidersFrom(BrowserModule, BrowserAnimationsModule, ModalModule.forRoot()),
		{
			provide: ErrorHandler,
			useClass: GlobalErrorHandler
		}
	],
  	bootstrap: [AppComponent]
})
export class AppModule { }
